<div #buffer [style.margin-top.rem]="2"></div>
<footer #footer class="sticky-footer">
  <div class="sticky-footer-content">
    <ng-content></ng-content>
  </div>
</footer>
